import { render, staticRenderFns } from "./FinalidadField.vue?vue&type=template&id=2631e04e&scoped=true&"
import script from "./FinalidadField.vue?vue&type=script&lang=js&"
export * from "./FinalidadField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2631e04e",
  null
  
)

export default component.exports